<template>
  <div class="agency-logo agency-logo-search">
    <template v-if="agencyLinkIntern != ''">
      <a
        :href="agencyLinkIntern"
        :title="agencyName"
      >
        <img
          :src="agencyLogoLink"
          :alt="agencyName"
        >
      </a>
    </template>
    <template v-else>
      <img
        :src="agencyLogoLink"
        :alt="agencyName"
      >
    </template>
  </div>
</template>

<script>
export default {
  props: {
    agencyName: {
      type: String,
      required: true,
    },
    agencyLinkIntern: {
      type: String,
      required: true,
    },
    agencyLogoLink: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.agency-logo-search {
  z-index: 5;
  left: 0.25em;
  bottom: 0.25em;
  position: absolute;

  /deep/ img {
    width: auto;
    height: auto;
  }
}

.agency-logo {
  margin: -2em 0 0 0;

  img {
    height: 2em;
  }
}
</style>
